import { AddressModel } from './address.model';

export interface CarrierModel {
  address: AddressModel;
  extId: string;
  id: string;
  name: string;
  // eslint-disable-next-line id-blacklist
  number: string;
  freeTextCarrierName: string;
}
